module.exports = __webpack_public_path__ + "img/off-button.a44ecb6e.png";